/**
 * ページ先頭に戻る
 */

export default {
    init: function (scroll) {
        document.querySelectorAll('.back-to-top a').forEach(link => {
            link.addEventListener('click', function (e) {
                e.preventDefault();
                scroll.scrollTo(0);
            });
        });
    }
};
